<template>
  <div class="popup-wrapper" @click.self="action.close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="action.close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">パーツの追加</span>
        </div>
        <div class="popup-content">
          <div class="button">
            <span @click="action.addText" role="button" class="btn">見出しの追加</span>
          </div>
          <div class="button mt12">
            <span @click="action.addTextarea"  role="button" class="btn">コメントの追加</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'PCNotePartAdd',
  setup (props, context) {
    const action = reactive({
      close: () => context.emit('close'),
      addText: () => context.emit('addText'),
      addTextarea: () => context.emit('addTextarea')
    })

    return {
      action
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
